<template>
  <div class="flex flex-wrap gap-3 font-medium">
    <slot />
  </div>
</template>
